var map = {
	"./admin.png": 2698,
	"./body_markers/anatomy.gif": 1322,
	"./body_markers/female.gif": 7603,
	"./body_markers/male.gif": 7884,
	"./celebration.png": 5851,
	"./consultMD_logo.png": 1296,
	"./consultderm_logo.png": 6471,
	"./doctor-diagnose-patient-symptoms-hospital 1.png": 7572,
	"./doctor_patient.png": 2720,
	"./doctors.png": 6527,
	"./doctorwriting.png": 9772,
	"./invite.png": 4196,
	"./lock.png": 2842,
	"./main.png": 2584,
	"./missing_patients.png": 8130,
	"./patients.png": 9685,
	"./profile.png": 7968,
	"./specialists.png": 2733,
	"./vault.png": 6579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;